import { ThemeEvents } from '@theme/events';

/**
 * Klarna Onsite Messaging — product only.
 *
 * Cart placement is rendered once in Liquid with `cart.total_price`. Do not
 * update or refresh it: attribute changes and SDK refresh() re-enter Klarna's
 * blurred loading state.
 */

/**
 * @param {unknown} cents
 */
function setProductPurchaseAmount(cents) {
  if (cents == null || Number.isNaN(Number(cents))) return;

  const amount = String(cents);
  document.querySelectorAll('.klarna-osm[data-klarna-context="product"] klarna-placement').forEach((el) => {
    if (!(el instanceof HTMLElement)) return;
    if (el.getAttribute('data-purchase-amount') === amount) return;
    el.setAttribute('data-purchase-amount', amount);
  });
}

document.addEventListener(ThemeEvents.variantUpdate, (event) => {
  setProductPurchaseAmount(event.detail?.resource?.price);
});
